/* Schemaform Field definition helper */
import { lazy } from "react";

// Normal imports
const TextField = require('components/util/schema_form/fields/TextField').default;
const NumberField = require('components/util/schema_form/fields/NumberField').default;
const DynamicSelectField = require('components/util/schema_form/fields/DynamicSelectField').default;
const TextAreaField = require('components/util/schema_form/fields/TextAreaField').default;
const ConfirmField = require('components/util/schema_form/fields/ConfirmField').default;
const CheckboxField = require('components/util/schema_form/fields/CheckboxField').default;
const FileField = require('components/util/schema_form/fields/FileField').default;
const LabelField = require('components/util/schema_form/fields/LabelField').default;
const ButtonField = require('components/util/schema_form/fields/ButtonField').default;
const ColorPickerField = require('components/util/schema_form/fields/ColorPicker').default;
const RecursiveSelectField = require('components/util/schema_form/fields/RecursiveSelectField').default;
const SmartTextField = require('components/util/schema_form/fields/smart_text/SmartText').default;

// Lazy imports
const HourField = lazy(() => import("components/util/schema_form/fields/HourField"));
const SelectField = lazy(() => import("components/util/schema_form/fields/SelectField"));
const LocationField = lazy(() => import("components/util/schema_form/fields/LocationField"));
const PhoneField = lazy(() => import("components/util/schema_form/fields/PhoneField"));
const CodeField = lazy(() => import("components/util/schema_form/fields/CodeField"));
const AssetField = lazy(() => import("components/util/schema_form/fields/AssetField"));
const SchemaBuilderField = lazy(() => import("components/util/schema_form/fields/SchemaBuilderField"));
const MatchField = lazy(() => import("components/util/schema_form/fields/MatchField"));
const VariableField = lazy(() => import("components/util/schema_form/fields/variable/VariableField"));
const AccountPicker = lazy(() => import("components/util/schema_form/fields/account_picker/AccountPicker"));
const RichText = lazy(() => import("components/util/schema_form/fields/rich_text/RichText"));
const FilterField = lazy(() => import("components/util/schema_form/fields/FilterField"));
const DataViewerField = lazy(() => import("components/util/schema_form/fields/DataViewer"));
const SelectorField = lazy(() => import("components/util/schema_form/fields/SelectorField"));
const ExcelField = lazy(() => import("components/util/schema_form/fields/ExcelField"));
const CollectionBuilderField = lazy(() => import("components/util/schema_form/fields/CollectionBuilderField"));

export {
    TextField,
    NumberField,
    DynamicSelectField,
    TextAreaField,
    CheckboxField,
    FileField,
    LabelField,
    ButtonField,
    ColorPickerField,
    RecursiveSelectField,
    ConfirmField,
    SmartTextField,
    SelectField,
    HourField,
    LocationField,
    AssetField,
    CodeField,
    SchemaBuilderField,
    MatchField,
    VariableField,
    AccountPicker,
    RichText,
    FilterField,
    DataViewerField,
    SelectorField,
    PhoneField,
    ExcelField,
    CollectionBuilderField
};

